import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getClienteId } from "../../redux/clientes/clientesAction";


export default function ClienteDetail(){
    const dispatch = useDispatch();
    const {id} = useParams();
    const clienteId = useSelector(state => state.clientes.clienteId);

    useEffect(() => {
        dispatch(getClienteId(id));
    }, [dispatch]);

    console.log(clienteId);
    

    return(
        <>
            <div className="bg-custom container-custom">
                <div className="container m-8 text-orange-500 text-[10pt] font-bold">
                    <p className="text-[14pt] mb-8">Detalle Cliente</p>
                <div>
                    <p className="my-2">Codigo Cliente: {clienteId.numCliente}</p>
                    <p>Nombre: {clienteId.nombre}</p>
                    <p className="my-2">Apellido: {clienteId.ciclo}</p>
                    <p>CUIT / CUIL / DNI: {clienteId.cuitCuilDni}</p>
                    <p className="my-2">Ciudad: {clienteId.ciudad}</p>
                    <p className="my-2">Direccion: {clienteId.direccion}</p>
                    <p className="my-2">CP: {clienteId.cp}</p>
                    <p className="my-2">Zona: {clienteId.zona}</p>
                    <p className="my-2">Telefono: {clienteId.telefono}</p>
                    <p className="my-2">Notas: {clienteId.notas}</p>
        </div>
                </div>
            </div>
        </>
    )
}